import script from "./Signals.vue?vue&type=script&setup=true&lang=js"
export * from "./Signals.vue?vue&type=script&setup=true&lang=js"

import "./Signals.vue?vue&type=style&index=0&id=ee80dd58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee80dd58"]])

export default __exports__